import type { IExperimentConfig } from '../types';

import { useGroup } from './useGroup';
import { useMemo } from 'react';

export function useExperiment(initialConfig: IExperimentConfig) {
  const control = useGroup(initialConfig.control);
  const variation = useGroup(initialConfig.variation);

  const experiment = useMemo(() => {
    return {
      getControl: () => control,
      getVariation: () => variation,
      getGroup: (index: number) => (index === 0 ? control : variation),
    };
  }, [control, variation]);

  return {
    getControl: experiment.getControl,
    getVariation: experiment.getVariation,
    getGroup: experiment.getGroup,
    getControlProps: control.getValues,
    getVariationProps: variation.getValues,
  };
}

export type IExperimentAdapter = ReturnType<typeof useExperiment>;
